// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cluster-list-marker {
  color: black;
  background: rgba(255, 255, 255, 0);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 3px solid #0d6efd;
  width: 40px; }

.list-marker {
  background: none;
  border: none; }

img {
  padding: 0; }

.list-marker img {
  width: 25px; }

.popup-card {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding-top: 1rem;
  padding-bottom: 1rem; }
  .popup-card h3 {
    font-size: 16px;
    color: #4fc2d9; }
  .popup-card h4 {
    font-size: 12px; }

.sw h3 {
  font-size: 12px;
  color: white; }

.mapboxgl-popup-content {
  width: 100% !important; }

.surface-water {
  color: black;
  background: rgba(255, 255, 255, 0);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 3px solid #0692ae; }

.popup-report-list {
  width: 50%;
  margin-bottom: 4px;
  margin-top: -8px; }
  .popup-report-list li {
    cursor: pointer;
    text-decoration: underline;
    font-weight: bold;
    color: #0d6efd; }

.popup-wrapper .mapboxgl-popup-content {
  width: 150% !important; }

.popup-wrapper .popup-context-menu-render-popup {
  text-align: left;
  border-radius: 4px;
  width: 160px !important;
  box-shadow: 0 3px 3px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  width: 100%;
  overflow: hidden;
  background-color: white; }
  .popup-wrapper .popup-context-menu-render-popup ul {
    list-style: none;
    margin-left: "-1rem";
    margin-bottom: 0;
    padding: 6px; }
  .popup-wrapper .popup-context-menu-render-popup .context-container-render-popup {
    margin-left: "-1rem"; }
  .popup-wrapper .popup-context-menu-render-popup .popup-context-item-render-popup {
    text-decoration: none !important;
    padding: 4px; }
  .popup-wrapper .popup-context-menu-render-popup .popup-hover-render-popup:hover {
    background-color: rgba(43, 10, 230, 0.261); }
  .popup-wrapper .popup-context-menu-render-popup .results-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center; }
`, "",{"version":3,"sources":["webpack://./src/components/AGTrueQIScores/water-quality-list.scss"],"names":[],"mappings":"AAEA;EACE,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW,EAAA;;AAGb;EACE,gBAAgB;EAChB,YAAY,EAAA;;AAGd;EACE,UAAU,EAAA;;AAGZ;EACE,WAAW,EAAA;;AAGb;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB,EAAA;EANtB;IAQI,eAAe;IACf,cAAc,EAAA;EATlB;IAYI,eAAe,EAAA;;AAInB;EAEI,eAAe;EACf,YAAY,EAAA;;AAIhB;EACE,sBAAsB,EAAA;;AAGxB;EACE,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB,EAAA;;AAG3B;EACE,UAAU;EACV,kBAAkB;EAClB,gBAAgB,EAAA;EAHlB;IAKI,eAAe;IACf,0BAA0B;IAC1B,iBAAiB;IACjB,cAAc,EAAA;;AAIlB;EAC8B,sBAAsB,EAAA;;AADpD;EAGM,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,wCAAwC;EACxC,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,uBAAuB,EAAA;EAV7B;IAYQ,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,YAAY,EAAA;EAfpB;IAkBQ,oBAAoB,EAAA;EAlB5B;IAqBQ,gCAAgC;IAEhC,YAAY,EAAA;EAvBpB;IA2BU,0CAA0C,EAAA;EA3BpD;IAgCQ,aAAa;IACb,8BAA8B;IAC9B,mBAAmB,EAAA","sourcesContent":["// Clusters\n\n.cluster-list-marker {\n  color: black;\n  background: rgba(255, 255, 255, 0);\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 3px solid #0d6efd;\n  width: 40px;\n}\n\n.list-marker {\n  background: none;\n  border: none;\n}\n\nimg {\n  padding: 0;\n}\n\n.list-marker img {\n  width: 25px;\n}\n\n.popup-card {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n  h3 {\n    font-size: 16px;\n    color: #4fc2d9;\n  }\n  h4 {\n    font-size: 12px;\n  }\n}\n\n.sw {\n  h3 {\n    font-size: 12px;\n    color: white;\n  }\n}\n\n.mapboxgl-popup-content {\n  width: 100% !important;\n}\n\n.surface-water {\n  color: black;\n  background: rgba(255, 255, 255, 0);\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 3px solid #0692ae;\n}\n\n.popup-report-list {\n  width: 50%;\n  margin-bottom: 4px;\n  margin-top: -8px;\n  li {\n    cursor: pointer;\n    text-decoration: underline;\n    font-weight: bold;\n    color: #0d6efd;\n  }\n}\n\n.popup-wrapper {\n    .mapboxgl-popup-content { width: 150% !important;}\n    .popup-context-menu-render-popup {\n      text-align: left;\n      border-radius: 4px;\n      width: 160px !important;\n      box-shadow: 0 3px 3px rgba(0, 0, 0, 0.2);\n      z-index: 1000;\n      width: 100%;\n      overflow: hidden;\n      background-color: white;\n      ul {\n        list-style: none;\n        margin-left: \"-1rem\";\n        margin-bottom: 0;\n        padding: 6px;\n      }\n      .context-container-render-popup {\n        margin-left: \"-1rem\";\n      }\n      .popup-context-item-render-popup {\n        text-decoration: none !important;\n    \n        padding: 4px;\n      }\n      .popup-hover-render-popup {\n        &:hover {\n          background-color: rgba(43, 10, 230, 0.261);\n        }\n      }\n    \n      .results-wrapper {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        #export-btn {\n          \n        }\n      }\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
